/* skeleton.tsx generated by @compiled/babel-plugin v0.40.0 */
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Box } from '@atlaskit/primitives/compiled';
import { useExperienceRenderAndMountMark, ExperienceMark } from '../../common/utils/experience-tracker';
import { useIntl } from 'react-intl';
import messages from './messages';

/*
  In the Remote App Switcher, the Skeleton component shows up first as a fallback while the full Remote App Switcher is still loading.
  Since the styles (compiled CSS) are lazy-loaded with the full App Switcher, they are not be ready when the Skeleton appears.
  This causes visual issues where the Skeleton looks broken

  To avoid this, we use inline styles instead. This guarantees that all required styles are applied immediately with the component.
  https://hello.jira.atlassian.cloud/browse/NAVX-676
*/
const iconSkeleton = <Box style={{
  display: 'inline-block',
  width: 32,
  height: 32,
  backgroundColor: "var(--ds-skeleton, #0515240F)",
  borderRadius: "var(--ds-radius-large, 8px)",
  marginRight: "var(--ds-space-100, 8px)"
}} />;
const lineSkeleton = <Box style={{
  display: 'inline-block',
  width: 260,
  height: 10,
  backgroundColor: "var(--ds-skeleton, #0515240F)",
  borderRadius: "var(--ds-radius-small, 4px)"
}} />;
export default ((): JSX.Element => {
  useExperienceRenderAndMountMark(ExperienceMark.SWITCHER_SKELETON_MOUNT);
  const {
    formatMessage
  } = useIntl();
  const items = <Box aria-hidden="true" style={{
    display: 'flex',
    paddingInline: "var(--ds-space-200, 16px)",
    paddingBlock: "var(--ds-space-100, 8px)",
    alignItems: 'center'
  }}>
			{iconSkeleton}
			{lineSkeleton}
		</Box>;
  return <Box as="section" style={{
    width: '343px',
    height: '80vh'
  }} role="alert" aria-label={formatMessage(messages.skeletonLoaderAriaLabel)} testId="skeleton">
			<Box aria-hidden="true" style={{
      paddingInline: "var(--ds-space-200, 16px)",
      paddingTop: "var(--ds-space-300, 24px)",
      paddingBottom: "var(--ds-space-100, 8px)"
    }}>
				{lineSkeleton}
			</Box>
			{items}
			{items}
			{items}
		</Box>;
});